import React from 'react'

const ErrorPage = ({ parsed }) => {
  let error = ''
  let error_desc = ''
  if (parsed !== null) {
    error = parsed.error
    error_desc = parsed.error_description
  }

  return (
    <div className="stdContent">
      <h1>Something went wrong: {error}</h1>
      <p>{error_desc}</p>
    </div>
  )
}

export default ErrorPage
